export default "__VITE_ASSET__ee40a42c__"